import { SUBMENU_PARAM_KEY } from '../../../../../constants/route'
import { useQueryParamSubTab } from '../../../../../hooks'
import { getSubSearchParam } from '../../../../../utils/route'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { getRequestProfileTabChatsPreferredSubTab } from '../../RequestProfileTabChats.utils'

export function useRequestProfileTabChatsActiveSubTab({
  allowedSubTabs,
  counters,
  isCountersReady,
}) {
  const { isPreview } = useRequestProfileContext()

  // Prefer the sub-tab with unread messages so entry needs no extra click.
  const preferredSubTab = getRequestProfileTabChatsPreferredSubTab({
    allowedSubTabs,
    counters,
  })

  const { activeSubTab, isValueFromUrl, setActiveSubTab } = useQueryParamSubTab(
    {
      allowedValues: allowedSubTabs,
      defaultValue: preferredSubTab,
      isUrlBound: !isPreview,
      paramKey: SUBMENU_PARAM_KEY,
      readValue: getSubSearchParam,
      // Only write ?sub= once a switcher exists (both chats) and the counters —
      // and thus the unread decision — have settled.
      writeDefaultOnEntry: allowedSubTabs.length > 1 && isCountersReady,
    }
  )

  // No valid `?sub=` yet and the unread decision hasn't settled — the caller
  // shows a loader rather than commit to a sub-tab that might change.
  const isResolvingInitialSubTab =
    allowedSubTabs.length > 1 && !isCountersReady && !isValueFromUrl

  return {
    activeSubTab,
    handleSetActiveSubTab: setActiveSubTab,
    isResolvingInitialSubTab,
  }
}
